<template>
    <div :class="topBorder" class="copyright-wrapper poppins-normal">
        CopyRight&reg; to MMCOA.
    </div>
</template>

<script>
export default {
    name: 'TheCopyRight',
    props: {
        topBorder: String,
    },
}

</script>

<style scoped>
.copyright-wrapper {
    text-align: center;
    width: 100%;
    padding: 10px 0;
    font-size: 11px;
}
</style>